var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 25.3334V7.6007C4.00004 7.04002 4.3508 6.53925 4.87772 6.34765L17.7722 1.65873C18.1182 1.5329 18.5007 1.71141 18.6266 2.05743C18.6531 2.13046 18.6667 2.20757 18.6667 2.28526V8.88902L27.0883 11.6962C27.6328 11.8777 28 12.3872 28 12.9611V25.3334H30.6667V28.0001H1.33337V25.3334H4.00004ZM6.66671 25.3334H16V5.14066L6.66671 8.53461V25.3334ZM25.3334 25.3334V13.9222L18.6667 11.6999V25.3334H25.3334Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2Line);
export default __webpack_public_path__ + "static/media/building-2-line.9b2e7933d13d493d372ccc26aef87d25.svg";
export { ForwardRef as ReactComponent };